export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5961.f31ba6f6.jpg";